import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { OrderReservationItem, getOrderReservationItems } from '@apis/order';

export const useOrderReservationItems = (orderId: number) => {
  const queryOptions: UseQueryOptions<
    PageResponse<OrderReservationItem>,
    Error
  > = {
    queryKey: ['orderReservationItems', orderId],
    queryFn: () => {
      return getOrderReservationItems(orderId);
    },
  };
  return useQuery(queryOptions);
};
